module.exports = __webpack_public_path__ + "static/media/tick@4x.5d3108c3.png";